import { render, staticRenderFns } from "./FeedbackQuestionform.vue?vue&type=template&id=1a0b5878&"
import script from "./FeedbackQuestionform.vue?vue&type=script&lang=js&"
export * from "./FeedbackQuestionform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports